import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const EmailConnectBanner = () => {
  const { user, impersonation } = useAuth();
  const { pathname } = useLocation();
  const [c, setC] = useState(null);
  const [busy, setBusy] = useState(false);
  const show = user?.role === "franchisee" && pathname.startsWith("/billing");
  useEffect(() => { if (show) api("/billing/connections").then(setC).catch(() => setC(null)); }, [show, pathname]);
  if (!show || !c || c.mail_provider || !c.gmail_available) return null;
  const connect = async () => {
    setBusy(true);
    try { const r = await api("/billing/oauth/gmail/start", { method: "POST", body: { origin_url: process.env.REACT_APP_BACKEND_URL } }); window.location.href = r.url; } catch (e) { toast.error(e.message); setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-[#F5A524]/60 bg-[rgba(245,165,36,0.1)] p-3" data-testid="email-connect-banner">
      <Mail size={18} className="shrink-0 text-[#F5A524]" />
      <p className="min-w-[200px] flex-1 text-xs text-[#ddd]">
        {impersonation ? "This franchisee hasn't connected their ALR email yet. Quotes and invoices can't be emailed from their inbox until they do." : <><b className="text-white">Connect your ALR email</b> so quotes, invoices and their PDFs go to customers from your own @alrclean.com inbox.</>}
      </p>
      {!impersonation && <button type="button" onClick={connect} disabled={busy} data-testid="email-connect-banner-btn" className="flex items-center gap-1.5 rounded-lg bg-[#F5A524] px-3.5 py-2 text-xs font-extrabold text-black transition-opacity disabled:opacity-50">{busy && <Loader2 size={13} className="animate-spin" />}CONNECT NOW</button>}
    </div>
  );
};
